import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';

export default ({ events, focus, view }) => {
    const extractDateRange = (range, transform) => {
        let results = [];
        let curDate = moment(range.start);
        let endDate = moment(range.end);
        if (
            moment(range.end).format('YYYY-MM-DD') >=
            moment(range.start).format('YYYY-MM-DD')
        ) {
            results.push(transform(moment(curDate), range));
            curDate.add(1, 'days');
            while (curDate <= endDate) {
                results.push(transform(moment(curDate), range));
                curDate.add(1, 'days'); // / add 1 day
            }
        }
        return results;
    };

    let allEvents = events.reduce(
        (current, item) =>
            current.concat(
                extractDateRange(item, (date, props) => ({
                    title: props.title,
                    startTime: moment(item.start).format('h:mm a'),
                    endTime: moment(item.end).format('h:mm a'),
                    date,
                    status: item.eventStatus,
                    className: item.className,
                    subStatus: item.eventSubStatus,
                    location: item.location,
                    url: item.url,
                    EventReport: item.EventReport,
                    start: item.start
                }))
            ),
        []
    );

    let filteredEvents = [];
    //Filter out data to show only the current day
    if (view === 'day') {
        filteredEvents = allEvents.filter(item => {
            return moment(focus).isSame(moment(item.date), 'day');
        });
    }

    //Filter out data that is only inside the current focus week Sun-Sat.
    if (view === 'week') {
        filteredEvents = allEvents.filter(item =>
            moment(item.date).isBetween(
                moment(focus).startOf('week'),
                moment(focus).endOf('week')
            )
        );
    }

    //Filter out data that is only inside the current month.
    if (view === 'month') {
        filteredEvents = allEvents.filter(item =>
            moment(item.date).isBetween(
                moment(focus).startOf('month'),
                moment(focus).endOf('month')
            )
        );
    }

    //Order the data by date and start time
    filteredEvents = _.sortBy(filteredEvents, ['date', 'startTime']);

    return (
        <table className={'calendar-events'}>
            <tbody>
                {filteredEvents.map((event, i) => {
                    return (
                        <tr key={i} className={'rbc-list-item calendar-event'}>
                            <td className={'calendar-event__time'}>
                                <span className={'calendar-event__date'}>
                                    {moment(event.date).format('ddd MMM D')}
                                </span>
                                <span className={'calendar-event__start'}>
                                    {event.startTime}
                                </span>
                                <span className={'calendar-event__end'}>
                                    {event.endTime}
                                </span>
                            </td>
                            <td
                                className={
                                    'calendar-event__legend ' + event.className
                                }
                            />
                            <td>
                                <Link
                                    to={event.url}
                                    className={event.className}
                                >
                                    <span className="rbc-event__title">
                                        {event.title}
                                    </span>
                                </Link>
                                {event.status && (
                                    <span className="rbc-event__status">
                                        <span className="rbc-event_sub-title">
                                            Status:
                                        </span>{' '}
                                        {event.status}
                                    </span>
                                )}
                                {event.subStatus && (
                                    <span className="rbc-event__substatus">
                                        <span className="rbc-event_sub-title">
                                            Sub Status:
                                        </span>{' '}
                                        {event.subStatus}
                                    </span>
                                )}
                                <span className="rbc-event__location">
                                    <span className="rbc-event_sub-title">
                                        Location:
                                    </span>{' '}
                                    {event.location}
                                </span>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};



// WEBPACK FOOTER //
// ./src/components/calendar/event-list.js